import { NavTabs } from '@mdvip/shared/components/blocks/NavTabs';
import { useTranslation } from 'react-i18next';

import { PATIENTS_TABS, type PatientsTabId } from '@/lib/patients/patientsTabs';

interface PatientsTabNavProps {
  active: PatientsTabId;
}

/** The Patients section's tab bar. A tab whose page hasn't shipped keeps its place, disabled. */
export function PatientsTabNav({ active }: PatientsTabNavProps) {
  const { t } = useTranslation('providers');

  return (
    <NavTabs
      label={t('pages.patients.tabs.label')}
      active={active}
      disabledHint={t('pages.patients.comingSoon')}
      items={PATIENTS_TABS.map((tab) =>
        tab.available
          ? { id: tab.id, label: t(tab.labelKey), to: `/patients/${tab.id}` }
          : { id: tab.id, label: t(tab.labelKey), disabled: true as const },
      )}
    />
  );
}
